import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Finance from './pages/homepage';
import Aboutt from './pages/aboutus';
import Blog from './pages/blog';
import BlogDetails from './pages/blogdetails';
import Services from './pages/services';
import Contact from './pages/contact';
import Tracker from './pages/tracker';
import Databank from './pages/databank';
import GetOffer from './pages/getoffer';
const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Finance/>}/> 
        {/* Blog Part  */}
        <Route path="/aboutus" element={<Aboutt/>}/>        
        <Route path="/blog" element={<Blog/>}/>
        <Route path="/blogdetails/:id" element={<BlogDetails/>}/>
        <Route path="/services" element={<Services/>}/>
        <Route path="/contact" element={<Contact/>}/>
        <Route path="/trackorder" element={<Tracker/>}/>
        <Route path="/databank" element={<Databank/>}/>
        <Route path="/getoffer" element={<GetOffer/>}/>
      </Routes>
    </Router>
  )
}

export default App
